import { LogLevel } from '@azure/msal-browser';
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

import * as msal from '@azure/msal-browser'
import router from '@/router'
import { withRetry } from '@/utils/NetworkRetry';

// eslint-disable-next-line no-unused-vars
export const msalConfig = {
  auth: {
    // DATOS PRO --> DESCOMENTAR PARA PRO Y COMENTAR "DATOS PRE" y "DATOS DEV"
    clientId: 'd2ec6049-8c88-476a-bb54-e95d83abc792',
    authority: 'https://login.microsoftonline.com/cd56815b-9436-42fb-a04d-475f95114903',
    redirectUri: 'https://cpq.henryschein.es', 
    postLogoutRedirectUri: 'https://cpq.henryschein.es/login',

    // DATOS TEST (GROUPS)
    // clientId: '9d9e7534-f479-43b0-b34e-7806d8b0638f',    
    // authority: 'https://login.microsoftonline.com/61c28c7f-8b62-4d11-bb44-db2335d67315',
    // redirectUri: 'http://localhost:8080/',     
    // postLogoutRedirectUri: 'localhost:8080/login'  

    // DATOS PRE --> DESCOMENTAR PARA PRE Y COMENTAR "DATOS DEV"
    // clientId: '2185220d-d3a0-423b-8f01-fef3b8f84d7d',
    // authority: 'https://login.microsoftonline.com/f93fb509-8a1b-4a1c-8aec-249d1458915d',
    // redirectUri: 'https://cpq.henryschein.es', 
    // postLogoutRedirectUri: 'https://cpq.henryschein.es/login',

    // DATOS DEV --> // DESCOMENTAR PARA DESARROLLAR Y COMENTAR "DATOS PRE"
    // clientId: '81d23138-ec07-42db-949c-27d26f6544e9',    
    // authority: 'https://login.microsoftonline.com/f93fb509-8a1b-4a1c-8aec-249d1458915d',
    // redirectUri: 'http://localhost:8080/',     
    // postLogoutRedirectUri: 'localhost:8080/login'     
    
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            // console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Verbose
    }
  }
};

/**
* Scopes you add here will be prompted for user consent during sign-in.
* By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
* For more information about OIDC scopes, visit:
* https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
*/
// eslint-disable-next-line no-unused-vars
export const loginRequest = {
  scopes: ['User.Read'],
  redirectStartPage: msalConfig.auth.redirectUri
}

/**
* Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
*/
// eslint-disable-next-line no-unused-vars
export const tokenRequest = {
  scopes: ['User.Read', 'Mail.Read'],
  forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
}


// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js
export const myMSALObj = new msal.PublicClientApplication(msalConfig)

export const handleRedirectPromise = myMSALObj.handleRedirectPromise();
handleRedirectPromise.then((response) => {
  handleRedirect(response);
});

let username = '';

// eslint-disable-next-line no-unused-vars
export function selectAccount() {
  /**
   * See here for more info on account retrieval:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
   */

  const currentAccounts = myMSALObj.getAllAccounts()
  if (currentAccounts.length === 0) {
    console.log("No account detected.");
  } else if (currentAccounts.length > 1) {
    // Add choose account code here
    console.warn('Multiple accounts detected.')
  } else if (currentAccounts.length === 1) {
    username = currentAccounts[0].username;
    myMSALObj.setActiveAccount(currentAccounts[0]);
    // eslint-disable-next-line no-undef
    // showWelcomeMessage(username)

    // Almacena el nombre de usuario en el localStorage
    localStorage.setItem('username', username);
  }
}

// eslint-disable-next-line no-unused-vars
async function handleResponse(response) {
  /**
   * To see the full list of response object properties, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#response
   */

  if (response !== null) {
    username = response.account.username
    // eslint-disable-next-line no-undef
    // showWelcomeMessage(username)
  } else {
    selectAccount()
  }
}

// eslint-disable-next-line no-unused-vars
async function handleRedirect(response) {
  console.log('handleRedirect>response>', response)
  /**
   * To see the full list of response object properties, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#response
   */

  if (response !== null) {
    myMSALObj.setActiveAccount(response.account);
    username = response.account.username;
    // router.replace("/"); // Quitamos esto para que sea el guard o el flujo natural quien maneje la navegación
  } else {
    selectAccount()
  }
}

// eslint-disable-next-line no-unused-vars
async function signIn() {
  /**
   * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
   */

  // myMSALObj.loginRedirect(loginRequest);


  myMSALObj.loginPopup(loginRequest)
    .then(handleResponse)
    .catch(error => {
      console.error(error)
    })

  // myMSALObj.loginRedirect(loginRequest)
  //   .then(handleRedirect)
  //   .catch(error => {
  //     console.error(error)
  //   })
}

// eslint-disable-next-line no-unused-vars
function signOut() {
  /**
   * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
   */

  // Choose which account to logout from by passing a username.

  const logoutRequest = {
    account: myMSALObj.getAccountByUsername(username)
  }

  myMSALObj.logout(logoutRequest)
}

async function getTokenPopup(request) {
  /**
   * See here for more info on account retrieval:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
   */
  console.log('username: ' + username)
  request.account = myMSALObj.getAccountByUsername(username)

  return await myMSALObj.acquireTokenSilent(request)
    .catch(error => {
      console.warn('silent token acquisition fails. acquiring token using popup')
      if (error instanceof msal.InteractionRequiredAuthError) {
        // fallback to interaction when silent call fails
        return myMSALObj.acquireTokenPopup(request)
          .then(tokenResponse => {
            console.log(tokenResponse)
            return tokenResponse
          }).catch(error => {
            console.error(error)
          })
      } else {
        console.warn(error)
      }
    })
}

export async function getTokenSilent() {
  try {
    let account = myMSALObj.getActiveAccount();
    if (!account) {
      const currentAccounts = myMSALObj.getAllAccounts();
      if (currentAccounts.length > 0) {
        account = currentAccounts[0];
        myMSALObj.setActiveAccount(account);
      }
    }

    if (!account) return null;

    const response = await withRetry(() =>
      myMSALObj.acquireTokenSilent({
        ...loginRequest,
        account: account || undefined
      })
    );

    return response.accessToken;
  }
  catch (ex) {
    console.warn("getTokenSilent failed completely after retries", ex);
    return null;
  }
}

// eslint-disable-next-line no-unused-vars
export async function isAuthenticated() {
  try {
    //debugger;
    const accessTokenRequest = {
      scopes: ['api://73d554dc-cc13-4e1a-92fd-f8b26ce75aa6/access_as_user']
    }
    const data = await getTokenPopup(accessTokenRequest)
    if (!data) {
      return false
    }
    console.log('data', data)
    return true
  } catch (ex) {
    console.log('ex', ex)
    return false
  }
}

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphMailEndpoint: 'https://graph.microsoft.com/v1.0/me/messages'
}


//TODO: AQUI YA SE ESTA SOLICITANDO TOKEN ANTES DE HACER LLAMADA A GRAPH
// eslint-disable-next-line no-unused-vars
function seeProfile() {
  getTokenPopup(loginRequest)
    .then(response => {
      callMSGraph(graphConfig.graphMeEndpoint, response?.accessToken, updateUI)
    }).catch(error => {
      console.error(error)
    })
}

//TODO: AQUI YA SE ESTA SOLICITANDO TOKEN ANTES DE HACER LLAMADA A GRAPH

// eslint-disable-next-line no-unused-vars
function readMail() {
  getTokenPopup(tokenRequest)
    .then(response => {
      callMSGraph(graphConfig.graphMailEndpoint, response?.accessToken, updateUI)
    }).catch(error => {
      console.error(error)
    })
}

/**
 * Helper function to call MS Graph API endpoint
 * using the authorization bearer token scheme
*/
function callMSGraph(endpoint, token, callback) {
  const headers = new Headers()
  const bearer = `Bearer ${token}`

  headers.append('Authorization', bearer)

  const options = {
    method: 'GET',
    headers: headers
  }

  console.log('request made to Graph API at: ' + new Date().toString())

  fetch(endpoint, options)
    .then(response => response.json())
    .then(response => callback(response, endpoint))
    .catch(error => console.log(error))
}

// const profileDiv = document.getElementById('profile-div')

function updateUI(data, endpoint) {
  console.log('Graph API responded at: ' + new Date().toString())
  console.log('graph>data', data)
  // if (endpoint === graphConfig.graphMeEndpoint) {
  //   profileDiv.innerHTML = ''
  //   const title = document.createElement('p')
  //   title.innerHTML = '<strong>Title: </strong>' + data.jobTitle
  //   const email = document.createElement('p')
  //   email.innerHTML = '<strong>Mail: </strong>' + data.mail
  //   const phone = document.createElement('p')
  //   phone.innerHTML = '<strong>Phone: </strong>' + data.businessPhones[0]
  //   const address = document.createElement('p')
  //   address.innerHTML = '<strong>Location: </strong>' + data.officeLocation
  //   profileDiv.appendChild(title)
  //   profileDiv.appendChild(email)
  //   profileDiv.appendChild(phone)
  //   profileDiv.appendChild(address)
  // } else if (endpoint === graphConfig.graphMailEndpoint) {
  //   if (data.value.length < 1) {
  //     alert('Your mailbox is empty!')
  //   } else {
  //     const tabContent = document.getElementById('nav-tabContent')
  //     const tabList = document.getElementById('list-tab')
  //     tabList.innerHTML = '' // clear tabList at each readMail call

  //     data.value.map((d, i) => {
  //       // Keeping it simple
  //       if (i < 10) {
  //         const listItem = document.createElement('a')
  //         listItem.setAttribute('class', 'list-group-item list-group-item-action')
  //         listItem.setAttribute('id', 'list' + i + 'list')
  //         listItem.setAttribute('data-toggle', 'list')
  //         listItem.setAttribute('href', '#list' + i)
  //         listItem.setAttribute('role', 'tab')
  //         listItem.setAttribute('aria-controls', i)
  //         listItem.innerHTML = d.subject
  //         tabList.appendChild(listItem)

  //         const contentItem = document.createElement('div')
  //         contentItem.setAttribute('class', 'tab-pane fade')
  //         contentItem.setAttribute('id', 'list' + i)
  //         contentItem.setAttribute('role', 'tabpanel')
  //         contentItem.setAttribute('aria-labelledby', 'list' + i + 'list')
  //         contentItem.innerHTML = '<strong> from: ' + d.from.emailAddress.address + '</strong><br><br>' + d.bodyPreview + '...'
  //         tabContent.appendChild(contentItem)
  //       }
  //     })
  //   }
  // }
}

export default {
  methods: {
    signIn,
    signOut,
    seeProfile,
    getTokenPopup,
    isAuthenticated
  },
  property: {
    username
  },
  msal
}